import { createNextTableContext } from '@shared/modules/next-table/context/context';

export const UsersTableContext = createNextTableContext();
export { DiscountUsersTableContext } from './discount';
